import { CSP_NONCE, Provider } from '@angular/core';

/**
 * Get the CSP nonce from the meta tag
 */
export function getNonce(): string {
    const metaTag = document.querySelector('meta[name="csp-nonce"]');
    const nonce = metaTag ? metaTag.getAttribute('content') || '' : '';

    // Set it globally for dynamic style injection in certain libraries
    if (nonce && typeof window !== 'undefined') {
        (window as any).__CSP_NONCE__ = nonce;
    }

    return nonce;
}

/**
 * Provider for CSP nonce
 */
export const CSP_NONCE_PROVIDER: Provider = {
    provide: CSP_NONCE,
    useFactory: getNonce,
};
